import {
  breakpointSizes,
  getBreakpointDown,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import Box from 'src/components/Box/Box'
import SvgChevronRight from 'src/components/Svgs/SvgChevronRight'
import UnavailableOptionTooltip from 'src/components/UnavailableOptionTooltip/UnavailableOptionTooltip'
import { css } from 'styled-components'

interface ChooseObjectTypeBoxProps {
  className?: string
  imageSrc: string
  title: React.ReactNode
  subtitle?: React.ReactNode
  onClick: () => void
  disabled?: boolean
  isSelected?: boolean
  isSmallerText?: boolean
  disableChevron?: boolean
  isSmallIcon?: boolean
  isSmallerPadding?: boolean
  isLargeIcon?: boolean
  id?: string
  userHasOrg?: boolean
}

const ChooseObjectTypeBox: React.FC<ChooseObjectTypeBoxProps> = (
  props,
): React.ReactElement => {
  return (
    <Box
      className={props.className}
      css={css`
        display: flex;
        align-items: center;

        ${!props.disabled &&
        css`
          cursor: pointer;
          transition: box-shadow 50ms ease-out;
          &:hover {
            box-shadow:
              0 1px 5px 0 rgba(0, 0, 0, 0.15),
              inset 0px 0px 0px 1px ${themeConstants.colors.cta};
          }
        `}

        ${!!props.isSmallIcon &&
        css`
          align-items: flex-start;
        `}

        ${!!props.isSmallerPadding &&
        css`
          padding: 20px 20px;
        `}

        ${!!props.isSelected &&
        css`
          border: 2px solid ${themeConstants.colors.cta};
        `}

        ${!!props.disabled &&
        css`
          opacity: 50%;
        `}
      `}
      onClick={props.disabled ? undefined : props.onClick}
    >
      <img
        css={css`
          ${!!props.isLargeIcon &&
          css`
            width: 100px;
            height: 100px;
          `}

          ${!!props.isSmallIcon &&
          css`
            width: 32px;
          `}

          ${getBreakpointDown(breakpointSizes.XSM)(css`
            width: 64px;
          `)}
        `}
        src={props.imageSrc}
        alt={''}
      />
      <div
        id={props.id ? props.id : 'chooseObjectBox'}
        css={css`
          display: flex;
          flex-direction: column;
          margin-left: 30px;

          ${getBreakpointDown(breakpointSizes.XSM)(css`
            margin-left: 16px;
          `)}

          ${props.subtitle === undefined &&
          css`
            align-self: center;
          `}
        `}
      >
        <span
          css={css`
            ${getFontCss(
              20,
              themeConstants.colors.cta,
              styleConstants.fontFamilies.medium,
            )};
            display: flex;
            align-items: center;
            margin-bottom: 10px;

            ${!!props.isSmallerText &&
            css`
              ${getFontCss(
                16,
                themeConstants.colors.font_primary,
                styleConstants.fontFamilies.medium,
              )};
            `}

            ${props.subtitle === undefined &&
            css`
              margin-bottom: 0px;
            `}

            ${getBreakpointDown(breakpointSizes.XSM)(css`
              ${getFontCss(
                16,
                themeConstants.colors.cta,
                styleConstants.fontFamilies.medium,
              )};
            `)}
          `}
        >
          {props.title}
          {props.disabled && props.userHasOrg && (
            <UnavailableOptionTooltip openLeft={false} />
          )}
          {!props.disabled && !props.disableChevron && <SvgChevronRight />}
        </span>
        {props.subtitle && (
          <span
            css={css`
              ${getFontCss(
                16,
                themeConstants.colors.font_primary,
                styleConstants.fontFamilies.regular,
              )};

              ${!!props.isSmallerText &&
              css`
                ${getFontCss(
                  12,
                  styleConstants.colors.gray_darkest,
                  styleConstants.fontFamilies.regular,
                )};
              `}

              ${getBreakpointDown(breakpointSizes.XSM)(css`
                ${getFontCss(
                  14,
                  styleConstants.colors.gray_darkest,
                  styleConstants.fontFamilies.regular,
                )};
              `)}
            `}
          >
            {props.subtitle}
          </span>
        )}
      </div>
    </Box>
  )
}

export default ChooseObjectTypeBox
